import { Form } from 'react-bootstrap';
import styles from './auth.module.scss';
import { useEffect, useState } from 'react';
import apiService from '@/api-service';
import { useDispatch } from 'react-redux';
import { authActions } from '@/store/reducers/auth';
import { loginRequest } from '@/config/auth';
import { useMsal } from '@azure/msal-react';

export default function AuthPage() {
    const dispatch = useDispatch();
    const { instance } = useMsal();

    const enableAADSignin: boolean = process.env.REACT_APP_ENABLE_AZURE_AD_SIGNIN === "true";

    const imagePath: string = `${process.env.PUBLIC_URL}/images/CROW-logo.svg`.replace("//", "/");

    const [ username, setUsername ] = useState<string>("");
    const [ password, setPassword ] = useState<string>(""); 
    
    const [ error, setError ] = useState<string | null>(null);

    useEffect(() => {
        const account = instance.getActiveAccount();
        if (account) {
            instance.acquireTokenSilent({ scopes: loginRequest.scopes, account: account });
        }
    })
/*
    const handleSignIn = (): void => {
        dispatch(authActions.signin({ method: 'bypass', token: 'temporary_token' }));
        // Navigeer naar het volgende scherm
    }*/
    
    const handleSignIn = (): void => {
        if (username.length === 0 || password.length === 0) {
            setError("Vul a.u.b een gebruikersnaam en een wachtwoord in.");
        } else {
            apiService.post<{token: string}>('/auth/get-token/', { username: username, password: password })
                .then((res) => {
                    setError(null);
                    dispatch(authActions.signin({ method: 'crow', token: res.data.token }));
                }, (e) => {
                    console.log(e);
                    setError("Ongeldige combinatie van gebruikersnaam en wachtwoord.");
                })
        }
    }

    const handleSignInWithMicrosoft = (): void => {
        instance.loginRedirect(loginRequest);
    }

    const microsoftLogoPath = `${process.env.PUBLIC_URL}/ms-symbollockup_mssymbol_19.png`.replace("//", "/");

    return (
        <div className={styles.outer_container}>
            <div className={styles.inner_container}>
                <img className={styles.logo} src={imagePath} alt="Logo" />

                <div className={styles.error_container}>
                {
                    error && (
                        <div className={styles.error}>
                            { error }
                        </div>
                    )
                }
                </div>

                <div className={styles.form_fields}>
                    <Form.Control value={username} onChange={(e) => setUsername(e.target.value)} type="text" placeholder="Gebruikersnaam" />
                    <Form.Control className="mt-1" value={password} type="password" placeholder="Wachtwoord" onChange={(e) => setPassword(e.target.value)} />
                </div>

                <div className={styles.button} onClick={handleSignIn}>
                    Inloggen
                </div>

                { enableAADSignin && (
                    <div className={styles.sign_in_microsoft_container} onClick={handleSignInWithMicrosoft}>
                        <img src={microsoftLogoPath} />
                        <div>Sign in with Microsoft</div>
                    </div>
                )} 
            </div>
        </div>
    )
}